import { utcToZonedTime } from 'date-fns-tz';

export function getTimeZone () {
  if(typeof window === 'undefined' || 
     typeof Intl.DateTimeFormat !== 'function' || 
     typeof Intl.DateTimeFormat().resolvedOptions !== 'function') {
    return process.env.APP_CONFIG.TIMEZONE;
  }

  return Intl.DateTimeFormat().resolvedOptions()?.timeZone ?? process.env.APP_CONFIG.TIMEZONE;
}

export function toZonedTime (date: number | string | Date) {
  return utcToZonedTime(date, getTimeZone());
}

export function getZonedDate (date?: number | string | Date) {
  return toZonedTime(date === undefined ? new Date() : date);
}
